<div class="multi-step-form min-vh-100 d-flex flex-column">
    <div class="d-flex justify-content-end align-items-center mt-2 px-3">
        <button class="btn btn-sm border-0 rounded bg-transparent d-flex align-items-center fw-bold text-white">
            <i class="bi bi-box-arrow-right fs-4 icon-white me-2"></i>
            <a href="/" class="text-xs text-white text-decoration-none"></a>
        </button>
    </div>

    <div class="forms-container d-flex justify-content-center pt-4 px-3">
        <div class="w-65 col-xl-7 col-lg-8 col-md-10 col-12">
            <div class="form-header btn-primary-dark fw-bold text-x mt-2 mb-4 border-0">
                {{ title }}
            </div>
            <div class="card shadow-sm border-0">
                <div class="glassy-bg rounded-lg">

                    <div class="form-fields-container p-3">
                        <div class="mb-3">
                            <label class="text-xxs fw-bold">Review Platform Consent</label>
                            <div class="border rounded p-3 bg-light overflow-y-auto">
                                <p class="text-xxs mb-2">
                                    In terms of the Protection of Personal Information Act ("POPI Act"), a "Responsible Party"
                                    (in this case being IHSS – "the Company") has a legal duty to process a "Data Subject's"
                                    personal information (in this case being your personal information and related details)
                                    in a lawful, legitimate and responsible manner.
                                </p>
                                <ul class="text-xxs ps-3 mb-3">
                                    <li class="mb-1">The Company is required to process your personal information for various reasons relating to your personal details within the Safety files or Safety Management system.</li>
                                    <li class="mb-1">In order to discharge its duty in terms of the POPI Act, the Company requires your express and informed permission to process your personal information.</li>
                                </ul>

                                <p class="text-xs fw-bold mb-1">Declaration and Informed Consent</p>
                                <ul class="text-xxs ps-3 mb-3">
                                    <li class="mb-1">I declare that the personal information I supplied to the Company at the time of onboarding and supplied thereafter at any time with the Company is accurate, up to date, not misleading, and complete in all respects.</li>
                                    <li class="mb-1">I give the Company consent and permission to process my personal information as necessary and for legitimate business purposes, and acknowledge that I understand the purposes for which it is required and for which it will be used.</li>
                                </ul>

                            </div>
                        </div>
                        <div class="form-check mb-3">
                            <input class="form-check-input" type="checkbox" id="acknowledge_terms" v-model="acknowledged" />
                            <label class="form-check-label text-xxs" for="acknowledge_terms">
                                I have read and agreed to the Consent.
                            </label>
                        </div>
                        <div class="d-flex justify-content-end gap-2">
                            <button type="button" class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
                                :disabled="verification_running || !acknowledged" @click.prevent="accept_terms">
                                Accept
                            </button>
                            <button type="button" class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark" :disabled="verification_running"
                                @click.prevent="decline_terms">
                                Decline
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>